/**
 * Scroll to the corresponding entry in the country list on tab.
 */
export const handleRegionClick = (_: unknown, code: unknown) => {
  if (typeof code !== "string") {
    return;
  }

  const targetElement = document.getElementById(code);

  if (targetElement === null) {
    return;
  }

  targetElement.scrollIntoView({
    block: "center",
  });
};
